import React from "react";
import { FaIndustry, FaGlobe, FaTruck } from "react-icons/fa";

const Experience = () => {
  return (
    <div className="bg-gradient-to-r from-green-200 via-indigo-100 to-green-100 py-16">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-10">
          16+ Years of Industrial Expertise
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">

          {/* Manufacturing */}
          <div className="flex items-center bg-gray-100 p-6 rounded-2xl w-full md:w-1/3 border border-gray-200 hover:shadow-xl hover:scale-105 transition">
            <div className="bg-emerald-500/10 p-4 rounded-full mr-4">
              <FaIndustry className="text-emerald-600 text-4xl" />
            </div>
            <div>
              <h3 className="text-gray-800 font-semibold text-xl">Manufacturing</h3>
              <p className="text-gray-600 text-sm mt-1">
                Precision-driven production with global standards.
              </p>
            </div>
          </div>

          {/* Exporting */}
          <div className="flex items-center bg-gray-100 p-6 rounded-2xl w-full md:w-1/3 border border-gray-200 hover:shadow-xl hover:scale-105 transition">
            <div className="bg-emerald-500/10 p-4 rounded-full mr-4">
              <FaGlobe className="text-emerald-600 text-4xl" />
            </div>
            <div>
              <h3 className="text-gray-800 font-semibold text-xl">Exporting</h3>
              <p className="text-gray-600 text-sm mt-1">
                Reliable export operations across continents.
              </p>
            </div>
          </div>

          {/* Supplying */}
          <div className="flex items-center bg-gray-100 p-6 rounded-2xl w-full md:w-1/3 border border-gray-200 hover:shadow-xl hover:scale-105 transition">
            <div className="bg-emerald-500/10 p-4 rounded-full mr-4">
              <FaTruck className="text-emerald-600 text-4xl" />
            </div>
            <div>
              <h3 className="text-gray-800 font-semibold text-xl">Supplying</h3>
              <p className="text-gray-600 text-sm mt-1">
                Efficient supply chain solutions worldwide.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Experience;